module.exports = __webpack_public_path__ + "static/media/league.d9c90c30.svg";